import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import CharacterView from "../components/charactersView";
import { chooseLanguage } from "../utils/chooseLanguage";
import Japanese from "./japanese";
import Switch from "../components/switch";

import "./styles.css";
import { ARABIC_TRANSLATION } from "../characters/translations/arabic";
import { CHINESE_TRANSLATION } from "../characters/translations/chinese";

export default function RootRoute() {
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  const location = useLocation();
  const currentRoute = location.pathname.split("/")[1];

  const language = chooseLanguage(currentRoute);

  return (
    <>
      <div className="languages">
        <div className="language-button-container">
          <Link to="/arabic">
            <button className="language-button">Arabic</button>
          </Link>
          <Link to="/chinese">
            <button className="language-button">Chinese</button>
          </Link>
          <Link to="/japanese">
            <button className="language-button">Japanese</button>
          </Link>
        </div>
        <Switch
          label="Display English Letters"
          handleToggle={handleToggle}
          isChecked={isChecked}
        />
      </div>
      {currentRoute === "japanese" ? (
        <Japanese isEnglishLetter={isChecked} />
      ) : (
        <CharacterView
          language={language}
          currentRoute={currentRoute}
          isEnglishLetter={isChecked}
          translationArray={
            currentRoute === "arabic" ? ARABIC_TRANSLATION : CHINESE_TRANSLATION
          }
        />
      )}
    </>
  );
}
